import { createAction } from "@ngrx/store";

const prefix = "[Skill Alias Page]";

export const editSkillDialogClosed = createAction(
  `${prefix} Edit Skill Dialog Closed`,
);
export const deleteSkillDialogClosed = createAction(
  `${prefix} Delete Skill Dialog Closed`,
);
